import { Component, OnInit, Output, EventEmitter, NgZone, AfterViewChecked, AfterViewInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ViewChild, ElementRef } from '@angular/core';
import * as moment from 'moment';
import { AuthService } from './../../../services/auth.service';
import { MemberService } from './../../../rest/api/member.service';
import { HelperService } from './../../../services/helper.service';
import { CountryService } from './../../../rest/api/country.service';

import { PaymentService } from './../../../rest/api/payment.service';

import { DateValidator } from './../../../validator/date-validator';
import { ImageHelper } from './../../../validator/image-helper';
import { ScrollHelper } from './../../../services/scroll-helper.service';

import * as _ from 'lodash';

declare var $: any;

import { DateTimeAdapter, OWL_DATE_TIME_FORMATS, OWL_DATE_TIME_LOCALE } from 'ng-pick-datetime';
import { MomentDateTimeAdapter } from 'ng-pick-datetime-moment';
import { DatePipe } from '@angular/common';

export const MY_CUSTOM_FORMATS = {
  datePickerInput: 'YYYY-MM-DD'
};

@Component({
  selector: 'app-createspace',
  templateUrl: './createspace.component.html',
  styleUrls: ['./createspace.component.scss'],
  providers: [
    { provide: DateTimeAdapter, useClass: MomentDateTimeAdapter, deps: [OWL_DATE_TIME_LOCALE] },
    { provide: OWL_DATE_TIME_FORMATS, useValue: MY_CUSTOM_FORMATS }
  ]
})
export class CreatespaceComponent implements OnInit, AfterViewChecked, AfterViewInit {
  @ViewChild('countryText') countryText: ElementRef;
  @Output() createSpaceEmit = new EventEmitter();
  @ViewChild('imageFile') imageFile: ElementRef;
  @ViewChild('audioFile') audioFile: ElementRef;

  @ViewChild('publishedDate') publishedDate: ElementRef;

  accessToken: any;
  createSpaceForm: FormGroup;
  imageLoader = false;

  isSubmitting = false;
  isSubmitted = false;
  loading = true;
  privateSpaceClicked = false;
  statusIconClicked = false;

  errors = [];
  successMsg: string;
  errorMsg: string;

  spaceCategoryData: any;

  urlPattern = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';

  uploadErr: string;
  selectedFile: any;
  thumbImage = '';
  imageData: any;
  fileText = '';
  countryData: any;
  filteredCountryData: any;
  selectedCountry: any;

  // Audio
  audioLoader = false;
  audioUploadErr: string;
  selectedAudioFile: any;
  audioData: any;
  audioText = '';

  langShortCode: any;

  // PAYMENT CARD INFO
  spacePlansData: any;
  taxPercentage = 0;
  cardData: any;
  cardLoader = true;

  // Space create form submitted
  createSpaceFormSubmitted = false;
  isSubmittingSpaceForm = false;
  isSubmittedSpaceForm = false;

  // Payment form
  createPaymentFormSubmitted = false;
  createPaymentForm: FormGroup;

  ccvCodeRegex = '^[0-9]{3,4}$';
  isSubmittingPaymentForm = false;
  isSubmittedPaymentForm = false;

  spaceConfig = {
    show_address: false,
    show_contact_email: false,
    show_contact_name: false,
    show_contact_phone: false,
    show_external_url: false,
    show_name_summary: false,
    show_published_date: false,
  };

  constructor(
    public router: Router,
    public fb: FormBuilder,
    private authService: AuthService,
    public memberService: MemberService,
    public helperService: HelperService,
    public scrollHelper: ScrollHelper,
    public paymentService: PaymentService,
    public countryService: CountryService,
    public datepipe: DatePipe
  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
    this.langShortCode = localStorage.getItem('language') ? localStorage.getItem('language') : undefined;
  }

  ngOnInit() {
    // this.resetErrorValues();
    this.getPlans();
    this.getPaymentCard();
    this.getSpaceCategory();
    this.createSpaceFormInit();
    this.createPaymentFormInit();
    this.getCountryData();
    this.fileText = 'Choose File';
    this.audioText = 'Choose File';
  }

  ngAfterViewInit(): void {
    // if (this.publishedDate && this.publishedDate.nativeElement && $(this.publishedDate.nativeElement)) {
    //   $(this.publishedDate.nativeElement).datepicker({
    //     format: 'yyyy-mm-dd'
    //   });
    // }
  }

  getCountryData() {
    this.countryService.getCountryName().subscribe((res: any) => {
      if (res && res.data) {
        this.countryData = res.data;
        this.filteredCountryData = res.data;
      } else {
        this.countryData = [];
        this.filteredCountryData = [];
      }
      const country = this.countryData ? _.find(this.countryData, { alpha_code: 'JP' }) : undefined;
      if (country) {
        this.selectedCountry = country;
      } else {
        this.selectedCountry = this.countryData && this.countryData[0] ? this.countryData[0] : undefined;
      }
      this.loading = false;
    }, err => {
      this.countryData = [];
      this.loading = false;
    });
  }

  changeCountry(country) {
    if (this.countryText) {
      this.countryText.nativeElement.value = '';
      this.filteredCountryData = this.countryData;
    }
    this.selectedCountry = country;
  }

  searchCountry(event) {
    if (event.target.value === '') {
      this.filteredCountryData = this.countryData;
    } else {
      this.filteredCountryData = _.filter(this.filteredCountryData, _.flow(
        _.identity,
        _.values,
        _.join,
        _.toLower,
        _.partialRight(_.includes, event.target.value)
      ));
    }
  }

  restrictNumeric(e) {
    let input;
    if (e.metaKey || e.ctrlKey) {
      return true;
    }
    if (e.which === 32) {
     return false;
    }
    if (e.which === 0) {
     return true;
    }
    if (e.which < 33) {
      return true;
    }
    input = String.fromCharCode(e.which);
    return !!/[\d\s]/.test(input);
   }

  getSpaceCategory() {
    if (this.langShortCode) {
      this.memberService.getSpaceCategory({
        Authorization: this.accessToken,
        lang: this.langShortCode
      }).subscribe((response: any) => {
        this.spaceCategoryData = response && response.data ? response.data : [];
      }, err => {
        this.spaceCategoryData = [];
      });
    } else {
      this.memberService.getSpaceCategory({
        Authorization: this.accessToken
      }).subscribe((response: any) => {
        this.spaceCategoryData = response && response.data ? response.data : [];
      }, err => {
        this.spaceCategoryData = [];
      });
    }
  }

  configChange(value) {
    this.spaceConfig[value] = !this.spaceConfig[value];
  }

  getPaymentCard() {
    this.memberService.getPaymentCard(this.accessToken).subscribe((response: any) => {
      const cardsList = response && response.data ? response.data : [];
      this.cardData = _.find(cardsList, {DefaultFlag: '1'});
      this.cardLoader = false;
    }, err => {
      this.cardLoader = false;
    });
  }

  getPlans() {
    this.paymentService.getPlans().subscribe((response: any) => {
      this.spacePlansData = response && response.plan ? _.find(response.plan, {plan_type: 'space' }) : undefined;
      const subscriptionPlan = response && response.plan ? (_.find(response.plan, {plan_type: 'subscription' }) ? _.find(response.plan, {plan_type: 'subscription' }) : false) : false;
      if (subscriptionPlan && subscriptionPlan.tax) {
        this.taxPercentage = subscriptionPlan.tax;
      }
    });
  }

  seperateDateFormat(carddate) {
    const splitted = carddate.match(/(.{1,2})/g);
    return splitted[0] && splitted[1] ? splitted[1] + '/' + splitted[0] : '-';
  }

  onFileChange(event) {
    this.imageLoader = true;
    this.uploadErr = undefined;
    if (event.target.files.length === 0) { return; }
    this.selectedFile = event.target.files[0] as File;

    const name = this.selectedFile && this.selectedFile.name;
    if (name) {
      this.fileText = name;
    }

    const fileExtension = name.split('.').pop();

    if (ImageHelper.isImageSizeExceeded(this.selectedFile.size)) {
      event.target.value = null;
      this.uploadErr = 'Please upload file less than 10 MB.';
      return;
    }

    if (ImageHelper.isImageTypeValid(fileExtension)) {
      event.target.value = null;
      this.uploadErr = 'Please upload valid file type (i.e jpeg, jpg, png, svg).';
      return;
    }
    this.imageData = undefined;
    this.authService.updateSpaceThumb(this.accessToken, this.selectedFile).subscribe((response: any) => {
      this.imageLoader = false;
      if (response && response.data && response.data.file) {
        this.createSpaceForm.controls.image.setValue(response.data.file);
      }
      if (response && response.data && response.data.url) {
        this.imageData = response.data.url;
      }
    }, err => {
      this.imageLoader = false;
      this.uploadErr = err.error && err.error.error ? err.error.error : 'There was error while uploading your file.';
    });

  }

  onFileAudioChange(event) {
    this.audioLoader = true;
    this.audioUploadErr = undefined;
    if (event.target.files.length === 0) { return; }
    this.selectedAudioFile = event.target.files[0] as File;

    const name = this.selectedAudioFile && this.selectedAudioFile.name;
    if (name) {
      this.audioText = name;
    }

    const fileExtension = name.split('.').pop();

    if (ImageHelper.isAudioSizeExceeded(this.selectedAudioFile.size)) {
      event.target.value = null;
      this.audioUploadErr = 'Please upload file less than 10 MB.';
      return;
    }

    if (ImageHelper.isAudioTypeValid(fileExtension)) {
      event.target.value = null;
      this.audioUploadErr = 'Please upload valid file type (i.e mp3, mpga, wav, ogg, pcm).';
      return;
    }
    this.audioData = undefined;
    this.authService.updateSpaceAudio(this.accessToken, this.selectedAudioFile).subscribe((response: any) => {
      this.audioLoader = false;
      if (response && response.data && response.data.file) {
        this.createSpaceForm.controls.audio.setValue(response.data.file);
      }
      if (response && response.data && response.data.url) {
        this.audioData = response.data.url;
      }
    }, err => {
      this.audioLoader = false;
      this.audioUploadErr = err.error && err.error.error ? err.error.error : 'There was error while uploading your file.';
    });

  }

  isImageSizeExceeded(imageSize: number) {
    return imageSize > 2000000;
  }

  createSpaceFormInit() {
    this.createSpaceForm = this.fb.group({
      category_id: ['', [Validators.required]],
      title: ['', [Validators.required, Validators.maxLength(40)]],
      summary: [''],
      published_date: ['', [Validators.compose([DateValidator.dateVaidator])] ],
      external_url: ['', [Validators.pattern(this.urlPattern)]],
      author: ['', [Validators.maxLength(40)]],
      presented_by: ['', [Validators.maxLength(40)]],
      contact_name: ['', [Validators.maxLength(40)]],
      contact_phone: ['', [Validators.pattern(/^[0-9]{10,11}$/)]],
      contact_email: ['', [Validators.email, Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$')]],
      address: ['', [Validators.maxLength(40)]],
      image: [''],
      audio: [''],
      space_type: ['2D', [Validators.required]],
    });
  }

  // Payment form cvv
  createPaymentFormInit() {
    this.createPaymentForm = this.fb.group({
      // ccvCode: ['', [Validators.required, Validators.pattern(this.ccvCodeRegex)] ],
    });
  }

  submitPaymentForm(value) {
    if (!this.createPaymentForm.valid) {
      this.isSubmittingPaymentForm = true;
      // this.scrollHelper.scrollToFirst('has__error');
      return;
    }
    if (this.isSubmittedPaymentForm) {
      return;
    }
    this.isSubmittedPaymentForm = true;
    setTimeout(() => {
      this.createSpaceFormSubmitted = false;
      this.createPaymentFormSubmitted = true;
      this.isSubmittingPaymentForm = false;
      this.isSubmittedPaymentForm = false;
    }, 1000);
  }

  backToSpaceCreate() {
    this.createPaymentFormSubmitted = false;
    this.createSpaceFormSubmitted = false;
  }

  backtoPaymentForm() {
    this.createPaymentFormSubmitted = false;
    this.createSpaceFormSubmitted = true;
  }

  submitSpaceForm(value) {
    if (!this.createSpaceForm.valid || this.uploadErr) {
      this.isSubmittingSpaceForm = true;
      return;
    }
    if (this.isSubmittedSpaceForm) {
      return;
    }
    this.isSubmittedSpaceForm = true;
    const data = value;
    if (data.published_date) {
      data.published_date = moment(data.published_at, 'YYYY-MM-DD');
    }
    setTimeout(() => {
      this.createSpaceFormSubmitted = true;
      this.isSubmittedSpaceForm = false;
      this.isSubmittingSpaceForm = false;
    }, 1000);
  }

  submitForm() {
    if (!this.createSpaceForm.valid || this.uploadErr || !this.createPaymentForm.valid) {
      return;
    }
    if (this.isSubmitted) {
      return;
    }
    this.isSubmitted = true;
    const data = this.createSpaceForm.value;
    if (data.published_date) {
      data.published_date = moment(data.published_at, 'YYYY-MM-DD');
    }

    // Space config
    data.show_contact_name = this.spaceConfig.show_contact_name;
    data.show_contact_email = this.spaceConfig.show_contact_email;
    data.show_contact_phone = this.spaceConfig.show_contact_phone;
    data.show_address = this.spaceConfig.show_address;
    data.show_external_url = this.spaceConfig.show_external_url;
    data.show_published_date = this.spaceConfig.show_published_date;

    // data.cvv = this.createPaymentForm.value.ccvCode;
    data.country_code = this.selectedCountry.alpha_code;
    data.amount = this.getTotalPrice();
    this.createSpace(data);
  }

  resetErrors() {
    this.errorMsg = undefined;
    this.errors = [];
  }

  createSpace(data) {
    let formData;
    formData = data;
    formData = this.helperService.updateJsonFormat(formData);
    this.memberService.createMemberSpace({
      Authorization: this.accessToken,
      body: formData
    }).subscribe((response: any) => {
      this.resetForm();
      this.successMsg = 'Space was created successfuly.';
      // this.scrollHelper.scrollToFirst('alert-success');
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      setTimeout(() => {
        this.resetErrorValues();
        document.getElementById('closeSpaceModal').click();
        const responseData = response && response.data ? response.data : undefined;
        this.createSpaceEmit.emit(responseData);
      }, 2000);
    }, err => {
      this.handleErrors(err);
    });
  }

  resetForm() {
    this.isSubmitted = false;
    this.isSubmitting = false;
    this.createPaymentFormSubmitted = false;
    this.createSpaceFormSubmitted = false;
    this.resetFormValues();
  }

  resetFormValues() {
    this.createSpaceForm.reset({
      category_id: '',
      title: '',
      summary: '',
      published_date: '',
      external_url: '',
      author: '',
      presented_by: '',
      contact_name: '',
      contact_phone: '',
      contact_email: '',
      address: '',
      image: '',
      audio: '',
      space_type: '2D',
      show_address: '',
      show_contact_email: '',
      show_contact_name: '',
      show_contact_phone: '',
      show_external_url: '',
      show_name_summary: '',
      show_published_date: '',
    });
    this.createPaymentForm.reset({
      // ccvCode: ''
    });
  }

  handleErrors(err: any) {
    if (err.error && err.error.errors) {
      this.errors = err.error.errors;
    } else if (err.error && err.error.error) {
      this.errorMsg = err.error.error;
    } else {
      this.errorMsg = 'There was error while creating space.';
    }
    this.isSubmitted = false;
    this.isSubmitting = false;
    this.scrollHelper.scrollToFirst('alert-danger');
    setTimeout(() => {
      this.resetErrors();
    }, 5000);
  }

  resetErrorValues() {
    this.isSubmitted = false;
    this.errorMsg = undefined;
    this.successMsg = undefined;
    this.imageData = undefined;
    this.selectedFile = undefined;
    this.isSubmitting = false;
    this.uploadErr = undefined;
    if (this.imageFile) {
      this.imageFile.nativeElement.value = '';
    }
    // Audio
    this.audioLoader = false;
    this.audioUploadErr = undefined;
    this.selectedAudioFile = undefined;
    this.audioData = undefined;
    if (this.audioFile) {
      this.audioFile.nativeElement.value = '';
    }
    this.resetForm();
  }

  ngAfterViewChecked() {
    this.scrollHelper.doScroll();
  }

  getSubTotalPrice() {
    const subsriptionPrice = this.spacePlansData && this.spacePlansData.new_price ? this.spacePlansData.new_price : 0;
    return subsriptionPrice;
  }

  getTaxAmount() {
    if (this.taxPercentage && this.taxPercentage > 0) {
      const subTotalPrice = this.getSubTotalPrice();
      const taxAmount = subTotalPrice * this.taxPercentage / 100;
      return Math.round(taxAmount);
    }
    return 0;
  }

  getTotalPrice() {
    return this.getSubTotalPrice() + this.getTaxAmount();
  }

  removeAudioFile() {
    this.createSpaceForm.controls.audio.setValue('');
    if (this.audioFile) {
      this.audioFile.nativeElement.value = '';
    }
    this.audioLoader = false;
    this.audioUploadErr = undefined;
    this.selectedAudioFile = undefined;
    this.audioData = undefined;
    this.audioText = 'Choose File';
  }

  removeImageFile() {
    this.createSpaceForm.controls.image.setValue('');
  }

}
